
<ng-template #notesModal let-modal>
  <div class="notes-modal">
    <div class="notes-modal-header">
      <div class="d-flex align-items-start gap-3">
        <i class="bx bx-file notes-modal-heading-icon" aria-hidden="true"></i>
        <div>
          <h5 id="procurement-notes-title">Pre-Procurement Notes</h5>
          <p>Notes and images added for this procurement</p>
        </div>
      </div>
      <app-button
        icon="times"
        variant="outline"
        size="sm"
        [iconOnly]="true"
        title="Close"
        ariaLabel="Close"
        (clicked)="modal.dismiss()"
      ></app-button>
    </div>

    <div class="notes-modal-body">
      <div *ngIf="notesLoading" class="notes-message" role="status">
        Loading notes...
      </div>

      <div *ngIf="notesError" class="notes-message notes-error" role="alert">
        {{ notesError }}
      </div>

      <div
        *ngIf="!notesLoading && !notesError && procurementNotes.length === 0"
        class="notes-message"
      >
        No notes have been added for this procurement.
      </div>

     <article class="procurement-note" *ngFor="let note of procurementNotes">

  <!-- LEFT SIDE : NOTE -->
  <div class="procurement-note-text">
    <span>Note</span>
    <p>{{ note.note }}</p>
  </div>

  <!-- RIGHT SIDE : ATTACHMENTS -->
  <div
    class="procurement-note-images"
    *ngIf="note.attachments?.length"
    [ngClass]="{
      'single-attachment': note.attachments.length === 1,
      'two-attachments': note.attachments.length === 2,
      'three-attachments': note.attachments.length === 3,
      'multiple-attachments': note.attachments.length >= 4
    }"
  >

    <div
      class="procurement-attachment"
      *ngFor="let attachment of note.attachments"
    >

      <!-- IMAGE -->
      <ng-container *ngIf="attachment.isImage; else pdfAttachment">
        <img
          [src]="attachment.url"
          [alt]="attachment.name"
        />
      </ng-container>

      <!-- PDF -->
      <ng-template #pdfAttachment>
        <div class="procurement-note-file">

          <i class="bx bxs-file-pdf pdf-icon"></i>

          <div class="file-details">
            <span>{{ attachment.name }}</span>
            <small>PDF Document</small>
          </div>

          <div class="pdf-actions">

            <app-button
              icon="eye"
              variant="outline"
              size="sm"
              [iconOnly]="true"
              [iconOnlyBorderless]="true"
              title="View PDF"
              ariaLabel="View PDF"
              (clicked)="viewAttachment(attachment)"
            ></app-button>

            <app-button
              icon="download"
              variant="outline"
              size="sm"
              [iconOnly]="true"
              [iconOnlyBorderless]="true"
              title="Download PDF"
              ariaLabel="Download PDF"
              (clicked)="downloadAttachment(attachment)"
            ></app-button>

          </div>

        </div>
      </ng-template>

    </div>
  </div>

</article>
    </div>

    <div class="notes-modal-footer">
      <app-button
        label="Close"
        variant="outline"
        size="sm"
        (clicked)="modal.close()"
      ></app-button>
    </div>
  </div>
</ng-template>

<ng-template #pdfViewerModal let-modal>
  <div class="pdf-viewer-modal">
    <div class="pdf-viewer-header">

      <h5 class="mb-0">PDF Preview</h5>

      <div class="pdf-viewer-actions">
        <app-button
          icon="download"
          variant="outline"
          size="sm"
          [iconOnly]="true"
          [iconOnlyBorderless]="true"
          title="Download PDF"
          ariaLabel="Download PDF"
          (clicked)="downloadAttachment(selectedAttachment)"
        ></app-button>
        <app-button
          icon="times"
          variant="outline"
          size="sm"
          [iconOnly]="true"
          title="Close"
          ariaLabel="Close"
          (clicked)="modal.dismiss()"
        ></app-button>
      </div>

    </div>
    <div class="pdf-viewer-body">

      <iframe
        *ngIf="selectedPdfUrl"
        [src]="selectedPdfUrl"
        frameborder="0">
      </iframe>

    </div>
  </div>
</ng-template>
